import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Defaults to localStorage
import cartReducer from "./slices/CartSlice";
import bmiReducer from "./slices/BmiSlice";
import consultationReducer from "./slices/ConsultationSlice";
import vaccineConsultationReducer from './slices/vaccineConsultationSlice'; 
import { userReducer } from "./slices/userSlice";
import buildPackageReducer from "./slices/BuildPackageSlice";


// Combine all reducers
const rootReducer = combineReducers({
  user: userReducer,
  cart: cartReducer,
  bmi: bmiReducer,
  consultation: consultationReducer,
  vaccineConsultation: vaccineConsultationReducer,
  buildPackage: buildPackageReducer,
});

// Redux Persist configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user", "cart", "bmi", "consultation", "vaccineConsultation", "buildPackage"],
};

// Persist the root reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
const store = configureStore({
  reducer: persistedReducer,
});

// Create a persistor
const persistor = persistStore(store);

export { store, persistor };
